import zod from 'zod';
import { stringToListOfNumber, zodLimit, zodPage } from './helpers';

export const applications = [
    'guardian_app',
    'citizen_app',
    'school_app',
    'platform',
] as const;

export type Application = typeof applications[number];

export const termsDocumentTypes = [
    'terms_of_use',
    'privacy_policy',
] as const;

export type TermsDocumentType = typeof termsDocumentTypes[number];

export const termsLanguages = [
    'pt-br',
    'en-us',
] as const;

export type TermsLanguage = typeof termsLanguages[number];

export const DocumentsSchemas = {
    DocumentsList: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitIds: stringToListOfNumber.optional(),
        createdFrom: zod.coerce.number().optional(),
        createdTo: zod.coerce.number().optional(),
        userIds: stringToListOfNumber.optional(),
    }),
    DocumentCategories: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitIds: stringToListOfNumber.optional(),
    }),
    TermsAndPrivacyGuardianApp: zod.object({
        page: zodPage,
        limit: zodLimit(),
        documentType: zod.enum(termsDocumentTypes).optional(),
        language: zod.enum(termsLanguages).optional(),
        application: zod.enum(applications).optional(),
    }),
    TermsAndPrivacyCitizenApp: zod.object({
        page: zodPage,
        limit: zodLimit(),
        documentType: zod.enum(termsDocumentTypes).optional(),
        language: zod.enum(termsLanguages).optional(),
        application: zod.enum(applications).optional(),
    }),
    TermsAndPrivacyPlatformApp: zod.object({
        page: zodPage,
        limit: zodLimit(),
        documentType: zod.enum(termsDocumentTypes).optional(),
        language: zod.enum(termsLanguages).optional(),
        application: zod.enum(applications).optional(),
    }),
    TermsAndPrivacyGuardianForm: zod.object({
        id: zod.coerce.number().optional(),
        version: zod.coerce.number().optional(),
        mode: zod.enum(['view', 'duplicate', 'editScheduled']).optional(),
    }).optional(),
    TermsAndPrivacyCitizenForm: zod.object({
        id: zod.coerce.number().optional(),
        version: zod.coerce.number().optional(),
        mode: zod.enum(['view', 'duplicate', 'editScheduled']).optional(),
    }).optional(),
    TermsAndPrivacyPlatformForm: zod.object({
        id: zod.coerce.number().optional(),
        version: zod.coerce.number().optional(),
        mode: zod.enum(['view', 'duplicate', 'editScheduled']).optional(),
    }).optional(),
};
